// This file requires the following components:
// - rentals-form

class RentalsFormBadge extends HTMLElement {
  constructor() {
    super();

    this.badge = this.querySelector('[data-badge]');
  }

  connectedCallback() {
    if (!this.badge || !this.form) return;

    this.updateFiltersBadge();

    this.form.addEventListener('change', () => {
      this.updateFiltersBadge();
    });
  }

  updateFiltersBadge() {
    const { badge } = this;
    const inlineInputs = this.formInputs.filter((input) => !input.isDropdown || input.getAttribute('data-disable-badge'));
    const activesCount = inlineInputs.filter((input) => input.active).length;

    badge.classList.toggle('d-none', !activesCount);

    if (this.size === 'sm') return;

    this.classList.toggle('active', activesCount);
    badge.textContent = activesCount;
  }

  get form() {
    return document.querySelector(this.getAttribute('data-target')) || this.closest('rentals-form');
  }

  get formInputs() {
    return [...this.form.formInputs];
  }

  get size() {
    return this.getAttribute('data-size') || 'lg';
  }
}

customElements.define('rentals-form-badge', RentalsFormBadge);
